import useAppQuery from 'hooks/useAppQuery';
import { GetDirectBookingRatingStatsResponse } from 'models/Reviews';
import { useParams } from 'react-router-dom';
import API from 'services/API';

export const DIRECT_BOOKING_RATING_STATS_QUERY_KEY = 'directBookingRatingStats';

const useDirectBookingRatingStats = () => {
  const { uid: propertyUid } = useParams();

  const { data, isLoading } = useAppQuery(
    [DIRECT_BOOKING_RATING_STATS_QUERY_KEY, propertyUid],
    async () => {
      const response = await API.get<GetDirectBookingRatingStatsResponse>(
        `/api/v3/reviews/statistics?propertyUid=${propertyUid}`,
      );

      return response.data;
    },
    {
      enabled: !!propertyUid,
    },
  );

  return {
    directBookingRatingStats: data?.statistics,
    isLoading,
  };
};

export default useDirectBookingRatingStats;
